/* Continue only the footer's painted surface through the bottom outer strip. */
(() => {
  if(window.akFooterMobileBackgroundBound)return;
  window.akFooterMobileBackgroundBound=true;
  let frame=0;
  function sync() {
    frame=0;
    const footer=document.querySelector('.ak-theend-v2-mobile');
    const menu=document.querySelector('.ak-bottom-nav');
    const mobile=matchMedia('(max-width:1200px)').matches;
    const box=footer?.getBoundingClientRect();
    const menuBox=menu?.getBoundingClientRect();
    document.body.classList.toggle('ak-footer-bottom-background',Boolean(mobile && box && menuBox &&
      box.height>0 && box.top<menuBox.top && box.bottom>=innerHeight-2));
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
  document.addEventListener('scroll',schedule,{capture:true,passive:true});
  ['resize','pageshow','ak:boot-revealed','ak:global-frame-ready','ak:home-sticky-stage-landed'].forEach(name=>window.addEventListener(name,schedule));
  const resize=new ResizeObserver(schedule);
  document.querySelectorAll('.ak-theend-v2-mobile,.ak-bottom-nav').forEach(e=>resize.observe(e));
  schedule();
})();
